import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddAulaModal from '../Modals/AddAulaModal';
import AddModuloModal from '../Modals/AddModuloModal';
import { formatTime } from '../../../Components/jwtUtils';
import { customStyles } from '../../../utils/selectStyles';

const AulasManager = ({ token, idCurso: idCursoProp, idModulo: idModuloProp, dataCursos: dataCursosProp, moduloAtual: moduloAtualProp, onModuloCreated, onAulaCreated }) => {
    const [idCurso, setIdCurso] = useState(idCursoProp || "");
    const [dataModulos, setDataModulos] = useState([]);
    const [showModalAddAula, setShowModalAddAula] = useState(false);
    const [showModalAddModulo, setShowModalAddModulo] = useState(false);
    const [reloadData, setReloadData] = useState(false);
    const [dataCursos, setDataCursos] = useState(dataCursosProp || []);
    
    const [file0Selected, setFile0Selected] = useState(false);
    const [file1Selected, setFile1Selected] = useState(false);
    const [file2Selected, setFile2Selected] = useState(false);
    const [moduloAddFile, setModuloAddFile] = useState(false);
    const [uploadAulaProgress, setUploadAulaProgress] = useState(0);

    const {
        register: register_A,
        handleSubmit: handleSubmit_A,
        control: control_A,
        reset: reset_A,
        setValue: setValue_A,
        clearErrors: clearErrors_A,
        formState: { errors: errors_A },
    } = useForm();

    const {
        register: register_M,
        handleSubmit: handleSubmit_M,
        control: control_M,
        reset: reset_M,
        setValue: setValue_M,
        setError: setError_M,
        clearErrors: clearErrors_M,
        formState: { errors: errors_M },
    } = useForm();

    // Efeito para sincronizar idCurso quando prop mudar
    useEffect(() => {
        if (idCursoProp) {
            setIdCurso(idCursoProp);
        }
    }, [idCursoProp]);

    // Efeito para sincronizar dataCursos quando prop mudar
    useEffect(() => {
        if (dataCursosProp && dataCursosProp.length > 0) {
            setDataCursos(dataCursosProp);
        }
    }, [dataCursosProp]);

    // Buscar cursos se não fornecidos via prop
    useEffect(() => {
        if (!dataCursosProp && token) {
            async function fetchCursos() {
                try {
                    const response = await Api.get(`api/listar-todos-cursos`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setDataCursos(response.data);
                } catch (error) {
                    console.error("Erro ao carregar cursos:", error);
                }
            }
            fetchCursos();
        }
    }, [token, dataCursosProp]);

    // Efeito para carregar módulos quando um curso é selecionado
    // IMPORTANTE: Se idCursoProp estiver presente, significa que estamos na página Modulos
    // e não devemos buscar módulos aqui (a página já tem seus próprios módulos)
    useEffect(() => {
        if (!idCurso) return;

        async function fetchModulos() {
            try {
                const response = await Api.get(`api/listar-modulos/${idCurso}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataModulos(response.data);
            } catch (error) {
                console.error(error.response?.data?.message || error);
            }
        }

        fetchModulos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, idCurso]);

    const handleKeyPress = (e) => {
        const input = e.target;
        setTimeout(() => {
            input.value = formatTime(input.value);
        }, 0);
    };

    const onSubmitAddAula = async (data) => {
        const formData = new FormData();
        const htmlExt = typeof data.html_externo === 'string' ? data.html_externo.trim() : '';
        const isUrlExterna = htmlExt.length > 0;

        Object.keys(data).forEach(key => {
            if (isUrlExterna && key.startsWith('file_')) {
                return;
            }
            const value = data[key];
            if (key === 'html_externo' && !isUrlExterna) {
                return;
            }
            if (value === undefined || value === null) {
                return;
            }
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                if (value.length === 0) {
                    return;
                }
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, key === 'html_externo' ? htmlExt : value);
            }
        });

        try {
            const response = await Api.post("/api/novo-aula", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadAulaProgress(percentCompleted + "%");
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadAulaProgress('Aguarde... finalizando...');
                        }, 1000);
                    }
                }
            });

            reset_A();
            setFile0Selected(false);
            setFile1Selected(false);
            setFile2Selected(false);
            setUploadAulaProgress(0);
            setShowModalAddAula(false);

            // Chamar callback se fornecido
            if (onAulaCreated) {
                onAulaCreated();
            }

            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error("Erro ao criar nova aula:", error);
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar nova aula"
            };
        }
    };

    const onSubmitAddModulo = async (data) => {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Api.post("/api/novo-modulo", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            reset_M();
            setValue_M("thumbnail", "");
            
            return {
                success: true,
                message: response.data.message,
                onSuccess: onModuloCreated // Passar callback no resultado
            };
        } catch (error) {
            console.error("Erro ao criar novo módulo:", error);
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar novo módulo"
            };
        }
    };

    const openAddAulaModal = () => {
        setShowModalAddAula(true);
        setUploadAulaProgress(0);
        reset_A();
        // Pré-selecionar curso e módulo se fornecidos via props
        if (idCursoProp) {
            setIdCurso(idCursoProp);
        }
    };
    
    const openAddModuloModal = () => {
        setShowModalAddModulo(true);
        reset_M();
        clearErrors_M(); // Limpar erros ao abrir o modal
        // Pré-selecionar curso se fornecido via props
        if (idCursoProp) {
            setValue_M("idCurso", idCursoProp, { shouldValidate: false, shouldDirty: false });
            // Buscar nome do curso para exibir
            const buscarNomeCurso = async () => {
                if (dataCursos && dataCursos.length > 0) {
                    const curso = dataCursos.find(c => c.id === parseInt(idCursoProp));
                    if (curso) {
                        setValue_M("cursos_nome", curso.nome, { shouldValidate: false, shouldDirty: false });
                    }
                } else {
                    // Se não tiver cursos carregados, buscar o curso específico
                    try {
                        const response = await Api.get(`api/listar-todos-cursos`, {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        });
                        const curso = response.data.find(c => c.id === parseInt(idCursoProp));
                        if (curso) {
                            setValue_M("cursos_nome", curso.nome, { shouldValidate: false, shouldDirty: false });
                        }
                    } catch (error) {
                        console.error("Erro ao buscar curso:", error);
                    }
                }
            };
            buscarNomeCurso();
        }
    };

    return {
        openAddAulaModal,
        openAddModuloModal,
        showModalAddAula,
        setShowModalAddAula,
        onSubmitAddAula,
        renderModals: (dataCursosParam) => {
            const cursosParaUsar = dataCursosParam || dataCursos;
            return (
            <>
                <AddAulaModal
                    showModalAddAula={showModalAddAula}
                    setShowModalAddAula={setShowModalAddAula}
                    setShowModalAddModulo={setShowModalAddModulo}
                    setIdCurso={setIdCurso}
                    idCurso={idCurso}
                        idModulo={idModuloProp}
                        moduloAtual={moduloAtualProp}
                    file0Selected={file0Selected}
                    setFile0Selected={setFile0Selected}
                    file1Selected={file1Selected}
                    setFile1Selected={setFile1Selected}
                    file2Selected={file2Selected}
                    setFile2Selected={setFile2Selected}
                    uploadAulaProgress={uploadAulaProgress}
                    register_A={register_A}
                    control_A={control_A}
                    errors_A={errors_A}
                    handleSubmit_A={handleSubmit_A}
                    onSubmitAddAula={onSubmitAddAula}
                    setValue_A={setValue_A}
                    clearErrors_A={clearErrors_A}
                    setValue_M={setValue_M}
                    customStyles={customStyles}
                        dataCursos={cursosParaUsar}
                    dataModulos={dataModulos}
                />

                <AddModuloModal
                    showModalAddModulo={showModalAddModulo}
                    setShowModalAddModulo={setShowModalAddModulo}
                        setShowModalAddAula={idCursoProp ? undefined : setShowModalAddAula}
                        setReloadData={idCursoProp ? undefined : setReloadData}
                        reloadData={idCursoProp ? undefined : reloadData}
                    moduloAddFile={moduloAddFile}
                    setModuloAddFile={setModuloAddFile}
                    register_M={register_M}
                    errors_M={errors_M}
                    control_M={control_M}
                    handleSubmit_M={handleSubmit_M}
                    onSubmitAddModulo={onSubmitAddModulo}
                    handleKeyPress={handleKeyPress}
                        idCurso={idCursoProp}
                        dataCursos={cursosParaUsar}
                        setValue_M={setValue_M}
                        setError_M={setError_M}
                        clearErrors_M={clearErrors_M}
                />
            </>
            );
        }
    };
};

export default AulasManager; 